import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect, lazy, Suspense } from "react";
import HomePage from "./pages/HomePage";
import { logPageVisit } from "./utils/analytics";

// Lazy load all non-homepage routes for better Core Web Vitals
const BlogListPage = lazy(() => import("./pages/BlogListPage"));
const BlogArticlePage = lazy(() => import("./pages/BlogArticlePage"));
const PrivacyPolicyPage = lazy(() => import("./pages/PrivacyPolicyPage"));
const TermsOfServicePage = lazy(() => import("./pages/TermsOfServicePage"));
const AboutUsPage = lazy(() => import("./pages/AboutUsPage"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const AdvertisePage = lazy(() => import("./pages/AdvertisePage"));
const WriterProfilePage = lazy(() => import("./pages/WriterProfilePage"));

// Lazy load global overlays — not needed for initial paint
const PazHelper = lazy(() => import("./components/PazHelper"));
const CookieConsentBanner = lazy(() => import("./components/CookieConsentBanner"));

// Map paths to friendly names for analytics
const getPageName = (pathname) => {
  const pageNames = {
    '/': 'home',
    '/home': 'home',
    '/blog': 'blog',
    '/admin': 'admin',
    '/privacidad': 'privacidad',
    '/terminos': 'terminos',
    '/anunciate': 'anunciate',
    '/nosotros': 'nosotros',
    '/contacto': 'contacto',
  };
  
  // Check for blog article pages
  if (pathname.startsWith('/blog/')) {
    return 'blog-article';
  }
  
  return pageNames[pathname] || pathname;
};

// Analytics tracker component
function AnalyticsTracker() {
  const location = useLocation();
  
  useEffect(() => {
    // Log page visit with friendly name
    const pageName = getPageName(location.pathname);
    logPageVisit(pageName);
  }, [location]);
  
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <AnalyticsTracker />
      <div className="App">
        <Suspense fallback={<div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',backgroundColor:'#F9F7F1'}}><div style={{width:32,height:32,border:'3px solid #E0DCD0',borderTopColor:'#1C3A27',borderRadius:'50%',animation:'spin 0.8s linear infinite'}}/><style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style></div>}>
        <Routes>
          {/* Homepage at root */}
          <Route path="/" element={<HomePage />} />
          {/* Also keep /home for backward compatibility */}
          <Route path="/home" element={<HomePage />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogArticlePage />} />
          <Route path="/privacidad" element={<PrivacyPolicyPage />} />
          <Route path="/aviso-de-privacidad" element={<PrivacyPolicyPage />} />
          <Route path="/terminos" element={<TermsOfServicePage />} />
          <Route path="/nosotros" element={<AboutUsPage />} />
          <Route path="/contacto" element={<ContactPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/anunciate" element={<AdvertisePage />} />
          <Route path="/escritor/:slug" element={<WriterProfilePage />} />
        </Routes>
        </Suspense>
        {/* Paz Voice Helper - Available on all pages */}
        <PazHelper />
        {/* Cookie Consent Banner - GDPR/AdSense compliance */}
        <CookieConsentBanner />
      </div>
    </BrowserRouter>
  );
}

export default App;
